/**
 * Tasks → Scene writing handoff (#1110). Presence door only.
 */

import { sceneWritingPath } from './sceneWritingPath';

export function continueDraftingPath(storyId) {
  return sceneWritingPath(storyId);
}

export function reviewDraftPath(storyId) {
  const base = sceneWritingPath(storyId);
  if (!base || base === '/scene-writing') return base;
  return `${base}?review=1`;
}
